export default __webpack_public_path__ + "static/media/warehouse-material-handling.3dfacda5.svg";